import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="yd-container flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center" data-testid="not-found">
      <Compass className="h-14 w-14 text-bosphorus-300" aria-hidden />
      <p className="font-display text-5xl font-bold text-ink-900">404</p>
      <h1 className="font-display text-xl font-semibold text-ink-800">Aradığınız sayfa bulunamadı</h1>
      <p className="max-w-md text-sm text-ink-500">
        Bağlantı taşınmış veya kaldırılmış olabilir. Ana sayfadan aramanıza devam edebilirsiniz.
      </p>
      <div className="mt-2 flex gap-3">
        <Link to="/" className="yd-btn-primary">Ana Sayfa</Link>
        <Link to="/ara" className="yd-btn-secondary">Mekanları Keşfet</Link>
      </div>
    </div>
  );
}
